import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
// import styles from './PersonalInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { StatusInputWrapper } from '../../../../shared/components/StatusInputWrapper'

const LastName = ({ t, validateLastName, lastNameError, lastNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const lastName = useSelector((state) => state.app.personalInformation.lastName)

  const handleLastName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(changeObjectPropertyAction('personalInformation', 'lastName', name))
      validateLastName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurLastName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(changeObjectPropertyAction('personalInformation', 'lastName', name))
      validateLastName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={lastNameValid}
      errorMsg={lastNameError}
      t={t}
      label={t('personal_info.last_name')}
      customClasses={'fw-20'}
      isFocussed={isFocussed}
      id="LastName" name="LastName" type="text"
      aria-describedby="last-name"
      onChange={handleLastName}
      onBlur={onBlurLastName}
      onFocus={() => SetIsFocussed(true)}
      value={lastName}
      autoComplete="off"
      maxLength="200"
    />
  )
}

export default withTranslation('common')(LastName)